import { Icon } from '@/app_components/common/Icon';
import { InputV2 } from '@/app_components/ui/InputV2';

interface SignInReadOnlyEmailInputV2Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEditEmailClick: () => void;
  hasError?: boolean;
}

export const SignInReadOnlyEmailInputV2 = ({
  value,
  onChange,
  onEditEmailClick,
  hasError,
}: SignInReadOnlyEmailInputV2Props) => (
  <InputV2
    autoComplete='email'
    className='pointer-events-none'
    error={hasError}
    icon={{
      ariaLabel: 'Edit email',
      element: (
        <Icon
          icon='Pencil'
          size='sm'
          strokeWidth={1.5}
        />
      ),
      onClick: onEditEmailClick,
    }}
    id='email'
    label='Email'
    name='email'
    onChange={onChange}
    placeholder='Enter email'
    readOnly
    required
    tabIndex={-1}
    type='email'
    value={value}
  />
);
